module.exports = __webpack_public_path__ + "static/media/boxUser.8b23aadc.png";